import React from 'react'

export default function Register() {
    return (
        <div className='container'>
            <h1>register page</h1>
        </div>
    )
}
